import { LoadingStatusType } from "@/enums/enums";
import { VuexModule, Module, Mutation, Action } from "vuex-module-decorators";
import API from "@/service/index";
import { ToBankAccountList } from "@/service/finance/financeFacade";

@Module({ namespaced: true })
export default class Payment extends VuexModule {
  public bankAccountList: any = null;
  public bankReferenceLoadingStatus: LoadingStatusType = LoadingStatusType.None;

  get getAllBankAccountList() {
    return this.bankAccountList;
  }

  get getCashInBankAccountList() {
    const cashInBankAccountList = [];
    if (this.bankAccountList) {
      for (const bankAccount of this.bankAccountList) {
        if (bankAccount.isCashIn) {
          cashInBankAccountList.push(bankAccount);
        }
      }
    }
    return cashInBankAccountList;
  }

  get getCashOutBankAccountList() {
    const cashOutBankAccountList = [];
    if (this.bankAccountList) {
      for (const bankAccount of this.bankAccountList) {
        if (bankAccount.isCashOut) {
          cashOutBankAccountList.push(bankAccount);
        }
      }
    }
    return cashOutBankAccountList;
  }

  get getBankReferenceLoadingStatus(): LoadingStatusType {
    return this.bankReferenceLoadingStatus;
  }

  @Mutation
  public MutationSetBankReferenceLoadingStatus(status: LoadingStatusType) {
    this.bankReferenceLoadingStatus = status;
  }

  @Mutation
  public MutationSetBankAccountList(bankAccountList: any) {
    this.bankAccountList = bankAccountList;
  }

  @Action
  public DoGetAllMainBankAccount(isUseMainDatabase?: boolean) {
    const _isUseMainDatabase = isUseMainDatabase ? isUseMainDatabase : false;
    if (this.bankReferenceLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetBankReferenceLoadingStatus", LoadingStatusType.Loading);
      API.FinanceService.DoGetAllBankAccount(_isUseMainDatabase)
        .then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            const bankAccountList = ToBankAccountList(res.data.bankAccountList);

            this.context.commit("MutationSetBankAccountList", bankAccountList);
          }
          this.context.commit("MutationSetBankReferenceLoadingStatus", LoadingStatusType.Success);
        })
        .catch((error) => error);
    }
  }
}
